import { isNil } from "lodash";
import { Nullish } from "utility-types";

import { IIdentity } from "../../../shared/db";
import { createAction, setSessionStorage, useSelector, v } from "../../../lib";

export enum IdentityActionType {
  IDENTITY_SET = "IDENTITY_SET",
  IDENTITY_MFA_ENABLED_UPDATE = "IDENTITY_MFA_ENABLED_UPDATE",
}

export const doIDENTITY_SET = createAction(IdentityActionType.IDENTITY_SET);
export const doIDENTITY_MFA_ENABLED_UPDATE = createAction(
  IdentityActionType.IDENTITY_MFA_ENABLED_UPDATE,
);

type IdentityState = Partial<IIdentity> | null;

interface RootState {
  identity: IdentityState;
}

export const useSelectIdentity = () => {
  return useSelector((state: RootState) => state.identity);
};

export const identityActionCreators = {
  doIDENTITY_SET,
  doIDENTITY_MFA_ENABLED_UPDATE,
};

export const identityDefaultState: IdentityState = null;

type Action =
  | {
      type: IdentityActionType.IDENTITY_SET;
      payload: IdentityState | Nullish;
    }
  | {
      type: IdentityActionType.IDENTITY_MFA_ENABLED_UPDATE;
      payload: {
        mfaEnabled: boolean;
      };
    };

export const identityReducer = (
  state: IdentityState = identityDefaultState,
  { type, payload }: Action,
): IdentityState => {
  switch (type) {
    case IdentityActionType.IDENTITY_SET: {
      let newState: IdentityState;
      if (isNil(payload)) {
        newState = null;
      } else {
        newState = { ...payload };
      }
      setSessionStorage({ identity: newState });
      return newState;
    }
    case IdentityActionType.IDENTITY_MFA_ENABLED_UPDATE: {
      const newState = { ...state, mfaEnabled: payload.mfaEnabled };
      setSessionStorage({ identity: newState });
      return newState;
    }
    default:
      return state;
  }
};
